import React from 'react';

import { TableCell, TableRow } from '@material-ui/core';
import { ReactComponent as TickSVG } from 'assets/pics/tick.svg';
import classnames from 'classnames';
import PropTypes from 'prop-types';

import { ActionButton } from 'components/ActionButton/ActionButton';

import { TASK_STATUS } from 'global/constants';

import { prepValueForDisplay } from 'utils/DataUtils';
import { getMyTasksDetailPath } from 'utils/UrlUtil';

import './MyTaskTable.sass';

export const MyTaskTableRows = ({ tasks }) => {
  if (!tasks) return [];
  return tasks.map((task, index) => {
    return (
      <TableRow
        key={task.id}
        className={classnames({
          'my-task-table-row__bold': task.antragstatus === TASK_STATUS.NEW,
          'my-task-table-task': task.antragstatus !== TASK_STATUS.NEW,
        })}
        sx={{
          '&:last-child td, &:last-child th': { border: 0 },
        }}>
        <TableCell scope="task">{task.antragtyp}</TableCell>
        <TableCell align="left">{prepValueForDisplay(task.antragsubtyp)}</TableCell>
        <TableCell align="left">{task.eingangsdatum}</TableCell>
        <TableCell align="left" scope="task">
          <div className="my-task-table-task-status">
            <div className="my-task-table-task-status-text">{task.antragstatus}</div>
            <div className="my-task-table-task-status-icon">
              {task.antragstatus === TASK_STATUS.FINISHED ? <TickSVG /> : null}
            </div>
          </div>
        </TableCell>
        <TableCell align="right" className="action-buttons">
          <ActionButton
            inverted
            className={classnames('action-button-fixed-width', {
              'action-button-hidden': task.antragstatus !== TASK_STATUS.NEW,
            })}
            title="Aufgabendetails anzeigen"
            link={`${getMyTasksDetailPath()}?taskId=${task.id}`}
          />
        </TableCell>
      </TableRow>
    );
  });
};
MyTaskTableRows.propTypes = {
  tasks: PropTypes.array.isRequired,
  onTaskClick: PropTypes.func,
};
